import APIService from "./APIService";

/**
 * API service for the Scam Activity Map feature.
 * Communicates with /api/v1/scam/scam-activity endpoints.
 */
const ScamActivityAPI = {
  BASE_PATH: "/api/v1/scam/scam-activity",

  /**
   * Search for scam incidents near a given address.
   *
   * @param {Object} params
   * @param {string}   params.address      - Required. Full human-readable address.
   * @param {number}   params.radiusMiles  - Default 25.
   * @param {string}   params.dateFrom     - ISO date (yyyy-MM-dd).
   * @param {string}   params.dateTo       - ISO date (yyyy-MM-dd).
   * @param {string[]} params.scamTypes    - Optional filter list.
   * @returns {Promise<Object>} ScamMapSearchResponseDTO
   */
  search: async (params) => {
    try {
      return await APIService.post(`${ScamActivityAPI.BASE_PATH}/search`, params);
    } catch (error) {
      console.error("ScamActivityAPI.search error:", error);
      throw error;
    }
  },

  /**
   * Get the user's saved map address.
   * @returns {Promise<{savedAddress: string}>}
   */
  getSavedAddress: async () => {
    try {
      return await APIService.get(`${ScamActivityAPI.BASE_PATH}/saved-address`);
    } catch (error) {
      console.error("ScamActivityAPI.getSavedAddress error:", error);
      return { savedAddress: "" };
    }
  },

  /**
   * Save (or overwrite) the user's map address.
   * @param {string} address
   * @returns {Promise<{savedAddress: string}>}
   */
  saveAddress: async (address) => {
    try {
      return await APIService.put(`${ScamActivityAPI.BASE_PATH}/saved-address`, {
        address,
      });
    } catch (error) {
      console.error("ScamActivityAPI.saveAddress error:", error);
      throw error;
    }
  },
};

export default ScamActivityAPI;
